import { TextMetrics } from 'pixi.js';

class TextMetricController {
	constructor(vc, conf) {
		this.config = conf;
		this.customGrid = false;
		if (vc[this.config.item]) {
			this.vc = vc[this.config.item];
		} else {
			throw new Error(
				'SettigsItemController failed init ' + JSON.stringify(this.config)
			);
		}
		for (let i = 0; i < this.config.texts.length; i++) {
			const text = this.vc[this.config.texts[i].value];
			if (this.config.texts[i].custom) {
				text.anchor.set(0.5, 0);
				text.position.set(
					this.config.position.w / 2 + this.config.texts[i].offset?.x,
					this.config.texts[i].position.y
				);
			} else if (this.config.customGrid) {
				text.anchor.set(0.5, 0);
				text.position.set(
					this.config.texts[i].position.x / 2,
					this.config.texts[i].position.y / 2
				);
				const textMetrics = TextMetrics.measureText(text.text, text.style);
				text.style.wordWrapWidth =
					textMetrics.maxLineWidth / this.config.texts[i].maxLineWidth;
				text.style.wordWrap = this.config.texts[i].wordWrap;
			} else {
				text.anchor.set(0.5, 0);
				const textMetrics = TextMetrics.measureText(text.text, text.style);
				text.style.wordWrapWidth =
					textMetrics.maxLineWidth / this.config.texts[i].maxLineWidth;
				text.style.wordWrap = this.config.texts[i].wordWrap;
				text.position.set(
					this.config.position.w / 2,
					this.config.texts[i].position.y
				);
			}
		}
	}
}
export default TextMetricController;
